$(function () {
  "use strict";

  /**
   * メッセージを表示する
   **/
  function showMessage($polls, message) {
    $polls.find(".message").show().html(message);
  }

  function hideMessage($polls) {
    $polls.find(".message").hide();
  }

  function isVoted(post_id, poll_id) {
    var key = "polls_voted_" + post_id + "_" + poll_id;
    var voted = localStorage.getItem(key);
    return voted;
  }

  function setVoted(post_id, poll_id) {
    var key = "polls_voted_" + post_id + "_" + poll_id;
    localStorage.setItem(key, true);
  }

  /**
   * 投票結果を表示する
   **/
  function showPolls($polls) {
    var time = 1000;
    var request_cnt = 0;
    var nonce = $polls.data("nonce");
    var poll_id = $polls.data("poll-id");
    var post_id = $polls.data("post-id");
    var check_ip = $polls.data("check-ip");

    $.ajax({
      url: moko.ajaxurl,
      type: "POST",
      dataType: "json",
      timeout: time,
      cache: false,
      data: {
        action: "moko_polls",
        _ajax_nonce: nonce,
        method: "get",
        poll_id: poll_id,
        post_id: post_id,
        check_ip: check_ip,
      },
    })
      .fail(function (xhr, status, error) {
        console.log("failed: " + status + " " + xhr.status);
        console.log(error);
        if (status === "timeout" && request_cnt < 3) {
          time = time * 2;
          request_cnt++;
          return showPolls($polls);
        }
        showMessage($polls, "通信エラーが発生しました");
      })
      .done(function (data) {
        //console.log("result", data);
        hideMessage($polls);
        var sum = data.sum;

        // polls-vote-gaugeクラスがある場合はページローカルでゲージ計算
        var isLocalGauge = $polls.hasClass("polls-vote-inpage");
        var localSum = 0;

        //console.log("🔍 [Polls Debug] poll_id:", poll_id);
        //console.log("🔍 [Polls Debug] $polls classes:", $polls.attr("class"));
        //console.log("🔍 [Polls Debug] isLocalGauge:", isLocalGauge);
        //console.log("🔍 [Polls Debug] original sum:", sum);

        if (isLocalGauge) {
          // ページ上で表示されている投票項目のみを対象にする
          var visibleVoteIds = [];
          $("#polls-" + poll_id)
            .find("[id^='polls-vote-gage-']")
            .each(function () {
              var voteId = $(this).attr("id").replace("polls-vote-gage-", "");
              visibleVoteIds.push(voteId);
            });

          //console.log("🔍 [Polls Debug] visible vote IDs on page:", visibleVoteIds);

          visibleVoteIds.forEach(function (voteId) {
            if (data[voteId] !== undefined) {
              //console.log("🔍 [Polls Debug] adding to localSum - key:", voteId, "value:", data[voteId]);
              localSum += data[voteId];
            }
          });
          //console.log("🔍 [Polls Debug] calculated localSum:", localSum);
        }

        var calculatedSum = isLocalGauge ? localSum : sum;
        //console.log("🔍 [Polls Debug] final calculatedSum:", calculatedSum);

        Object.keys(data).forEach(function (key) {
          if (key === "sum") {
            return;
          }

          var value = data[key];
          $("#polls-" + poll_id)
            .find("#polls-vote-" + key)
            .html(value);
          //$('#polls-vote-'+key).html(value);
          var rate = Math.round((value / calculatedSum) * 100, 3);
          //console.log("🔍 [Polls Debug] key:", key, "value:", value, "rate:", rate + "%", "calculatedSum:", calculatedSum);
          $("#polls-" + poll_id)
            .find("#polls-vote-gage-" + key)
            .css("width", rate + "%");
          //console.log(key,value,rate);
        });
        votes_sort(poll_id);
      });
  }

  //投票ボタンを押す
  function clickPolls($button) {
    var $polls = $button.parents(".polls");

    var nonce = $polls.data("nonce");
    var poll_id = $polls.data("poll-id");
    var post_id = $polls.data("post-id");
    var vote_id = $button.data("vote-id");
    var check_ip = $polls.data("check-ip");
    var title = $button.data("title");

    if (isVoted(post_id, poll_id)) {
      alert("すでに投票済みです");
      return;
    }

    $.ajax({
      url: moko.ajaxurl,
      type: "POST",
      dataType: "text",
      timeout: 5000,
      cache: false,
      data: {
        action: "moko_polls",
        _ajax_nonce: nonce,
        method: "vote",
        poll_id: poll_id,
        post_id: post_id,
        vote_id: vote_id,
        check_ip: check_ip,
        title: title,
      },
    })
      .fail(function (xhr, status, error) {
        console.log("failed: " + status + " " + xhr.status);
        console.log(error);
        showMessage($polls, "通信エラーが発生しました");
      })
      .done(function (data) {
        console.log("result", data);
        showMessage($polls, "投票ありがとうございました");
        var num = $("#polls-" + poll_id)
          .find("#polls-vote-" + vote_id)
          .html();
        num++;
        $("#polls-" + poll_id)
          .find("#polls-vote-" + vote_id)
          .html(num);
        setVoted(post_id, poll_id, vote_id);
      });
  }

  /**
   * ソート
   **/
  function votes_sort(poll_id) {
    if (!isNaN(poll_id)) {
      poll_id = "polls-" + poll_id;
    }

    $("#" + poll_id)
      .find("#vote_num_asc")
      .html(
        $("#" + poll_id)
          .find("#vote_num_asc tr")
          .sort(function (a, b) {
            var num1 = $(a).find(".polls-vote-num").text();
            var num2 = $(b).find(".polls-vote-num").text();
            return num1 - num2;
          })
      );

    $("#" + poll_id)
      .find("#vote_num_desc")
      .html(
        $("#" + poll_id)
          .find("#vote_num_desc tr")
          .sort(function (a, b) {
            var num1 = $(a).find(".polls-vote-num").text();
            var num2 = $(b).find(".polls-vote-num").text();
            return num2 - num1;
          })
      );

    $("#" + poll_id)
      .find("#gojuuon_asc")
      .html(
        $("#" + poll_id)
          .find("#gojuuon_asc tr")
          .sort(function (a, b) {
            var str1 = $(a).find(".polls-vote-title").text().toString();
            var str2 = $(b).find(".polls-vote-title").text().toString();
            return str1.localeCompare(str2);
          })
      );

    $("#" + poll_id)
      .find("#gojuuon_desc")
      .html(
        $("#" + poll_id)
          .find("#gojuuon_desc tr")
          .sort(function (a, b) {
            var str1 = $(a).find(".polls-vote-title").text().toString();
            var str2 = $(b).find(".polls-vote-title").text().toString();
            return str2.localeCompare(str1);
          })
      );
  }

  $(".sort_button").on("click", function () {
    var poll_id = $(this).parents().data("id");
    var button1 = $(this).prev("#sort_button_" + poll_id + "_1");
    var button2 = $(this).next("#sort_button_" + poll_id + "_2");

    if (button1.hasClass("active")) {
      button1.removeClass("active");
      button1.find("span").text("");
    }

    if (button2.hasClass("active")) {
      button2.removeClass("active");
      button2.find("span").text("");
    }

    if (!$(this).hasClass("active")) {
      $(this).toggleClass("active");
      $(this).find("span").text("▲");
    } else {
      if ($(this).find("span").is(":contains('▲')")) {
        $(this).find("span").text("▼");
      } else {
        $(this).find("span").text("▲");
      }
    }
    add_id(poll_id);
    votes_sort(poll_id);
  });

  function add_id(poll_id) {
    var button1 = $(".sort_button").prev("#sort_button_" + poll_id + "_1");
    var button2 = $(".sort_button").next("#sort_button_" + poll_id + "_2");

    if (button1.find("span").is(":contains('▲')")) {
      $("#" + poll_id)
        .find("table")
        .attr("id", "gojuuon_asc");
    } else if (button1.find("span").is(":contains('▼')")) {
      $("#" + poll_id)
        .find("table")
        .attr("id", "gojuuon_desc");
    }
    if (button2.find("span").is(":contains('▲')")) {
      $("#" + poll_id)
        .find("table")
        .attr("id", "vote_num_asc");
    } else if (button2.find("span").is(":contains('▼')")) {
      $("#" + poll_id)
        .find("table")
        .attr("id", "vote_num_desc");
    }
  }

  /**
   * 投票処理の初期化
   **/
  moko.initPolls = function (content) {
    //投票結果を表示
    content.find(".polls").each(function () {
      showPolls($(this));
    });

    //投票ボタンを押したときの処理
    content.on("click", ".polls-vote-button", function () {
      clickPolls($(this));
    });

    //console.log( 'init polls');
  };

  moko.initPolls($(document));
});
